
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import PageBase from "../../../../../engines/modules/uiModule/PageBase";
import { OilFieldBuyPrams } from "../../../../../engines/modules/uiModule/UIPrams";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import { getKaoguItemConfig, getKaoguMountainConfig, KaoguItemInfo, KaoguMountainInfo } from "./config/kaoguMountainConfig";


const { ccclass, property } = cc._decorator;

@ccclass
export default class outsideItemPage extends PageBase {
    @property({ type: cc.Sprite, displayName: "矿山图片" })
    img_oilfield: cc.Sprite = null;
    @property({ type: cc.Label, displayName: "矿山名称" })
    lab_name: cc.Label = null;
    @property({ type: cc.Label, displayName: "矿山价格" })
    lab_price: cc.Label = null;
    @property({ type: cc.Label, displayName: "矿山内容" })
    lab_tips: cc.Label = null;

    infoData: KaoguItemInfo = null

    callBack: () => void = null;
    rightcallBack: () => void = null;
    async OnPageOpen(prams?: OilFieldBuyPrams) {
        if (prams) {
            this.infoData = getKaoguItemConfig[prams.id];
            this.lab_name.string = this.infoData.nickName;
            this.lab_price.string = `${data_control.getNumberFormat(this.infoData.sellPrice)}`;
            this.lab_tips.string = this.infoData.tips;
            this.callBack = prams.callBack;
            this.rightcallBack = prams.rightcallBack;
            this.loadImg(this.img_oilfield, this.infoData.spriteimg)
        }
        super.OnPageOpen(prams)
    }
    clickTime: number = null;
    onClickMine() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this.ClosePage();
        this.callBack && this.callBack();
    }
    onCickVedioSell() {

        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (this.clickTime != null && new Date().getTime() - this.clickTime < 3000) return;
        this.clickTime = new Date().getTime()

        let func = () => {
            this.ClosePage();
            this.rightcallBack && this.rightcallBack();
        }
        cc.game.pause();
        utilsModel.loadAndShowVideoAdTrans(async () => {
            cc.game.resume();
            func();
        }, () => {
            cc.game.resume();
        }, null, '矿区看视频双倍倍卖出')
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this.ClosePage();
    }

    async loadImg(sprite: cc.Sprite, url: string) {
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.kaogu, false);
        await new Promise<void>(resolve=>{
            bundle.load('res/kaogu/kaoguitem/' + url, cc.Texture2D, (e, ass: cc.Texture2D) => {
                if (e) {
                    resolve();
                    return
                }
                const spriteFrame = new cc.SpriteFrame(ass);
                const maxSize = Math.max(spriteFrame.getOriginalSize().width, spriteFrame.getOriginalSize().height);
                sprite.spriteFrame = spriteFrame;
                const realMax: number = 220;
                const scale = realMax / maxSize;
                if (maxSize == spriteFrame.getOriginalSize().width) {
                    sprite.node.width = realMax;
                    sprite.node.height = spriteFrame.getOriginalSize().height * scale;
                } else {
                    sprite.node.height = realMax;
                    sprite.node.width = spriteFrame.getOriginalSize().width * scale;
                }
                resolve();
            })
        });
    }
}